/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" _fill="#C4FFF9" d="M75 120.832c-11.668 0-23.332-4.582-32.5-13.332-17.918-17.918-17.918-47.082 0-65s47.082-17.918 65 0 17.918 47.082 0 65c-9.168 8.75-20.832 13.332-32.5 13.332zM75 37.5c-9.582 0-19.168 3.75-26.668 10.832-14.582 14.582-14.582 38.332 0 52.918 14.582 14.582 38.332 14.582 52.918 0 14.582-14.582 14.582-38.332 0-52.918C94.168 41.25 84.582 37.5 75 37.5zm20.418 22.918l-5.832-5.832L75 69.168 60.418 54.582l-5.836 5.836L69.164 75 54.582 89.582l5.832 5.832 14.582-14.582 14.582 14.582 5.832-5.832L80.832 75l14.586-14.582z"/>'
  }
})
